import React from 'react';

function Footer() {
  return (
     <footer className="footer-landing">
        <div><span> &copy; {new Date().getFullYear()} - All Rights Reserved | <a href="http://www.hibbertgroup.com/privacy.html">Privacy</a></span></div>
      </footer>
  )
}

export default Footer